import { useEffect, useRef } from 'react';
import { refreshKeycloakSession } from '@/lib/keycloak';
import { useAuthStore } from '@/stores/auth-store';

const REFRESH_LEEWAY_MS = 60_000;

function expireToLogin() {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('token');
  localStorage.removeItem('idToken');
  localStorage.removeItem('expiresAt');
  localStorage.removeItem('user');

  useAuthStore.setState({
    user: null,
    expiresAt: null,
    isAuthenticated: false,
  });

  const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const params = new URLSearchParams({
    reason: 'session_expired',
    returnTo,
  });
  window.location.replace(`/login?${params.toString()}`);
}

export function useBrowserSessionRefresh() {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated);
  const expiresAt = useAuthStore(s => s.expiresAt);
  const updateSessionExpiry = useAuthStore(s => s.updateSessionExpiry);
  const refreshInFlightRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !expiresAt) {
      return;
    }

    const scheduleDelay = Math.max(0, expiresAt - Date.now() - REFRESH_LEEWAY_MS);

    const timer = window.setTimeout(() => {
      if (refreshInFlightRef.current) {
        return;
      }

      refreshInFlightRef.current = true;
      void refreshKeycloakSession()
        .then(session => {
          updateSessionExpiry(session.expiresIn);
        })
        .catch(() => {
          expireToLogin();
        })
        .finally(() => {
          refreshInFlightRef.current = false;
        });
    }, scheduleDelay);

    return () => window.clearTimeout(timer);
  }, [expiresAt, isAuthenticated, updateSessionExpiry]);
}
